import { supabase } from './supabase';
import { queryCache, CACHE_TTL } from './cache';

export async function fetchUserOrganizationRole(
  userId: string,
  organizationId: string,
  accessScope: string = 'footypicks'
): Promise<string | null> {
  const cacheKey = queryCache.generateKey('userOrganizationRole', {
    userId,
    organizationId,
    accessScope,
  });

  return queryCache.deduplicate(
    cacheKey,
    async () => {
      const { data, error } = await supabase
        .from('user_organizations')
        .select('role')
        .eq('user_id', userId)
        .eq('organization_id', organizationId)
        .eq('access_scope', accessScope)
        .maybeSingle();

      if (error) {
        throw error;
      }
      return data?.role ?? null;
    },
    CACHE_TTL.SHORT
  );
}

export function invalidateUserOrganizationRole(
  userId: string,
  organizationId: string,
  accessScope: string = 'footypicks'
): void {
  queryCache.invalidateByParams('userOrganizationRole', {
    userId,
    organizationId,
    accessScope,
  });
}
